const popOverWidth = 320;

export const styles = ({ palette, defaults, applyOpacityToHex, shadows, mixins }) => {
  const navMenuItem = {
    color: mixins.navigation.iconColor,
    opacity: mixins.navigation.rowOpacity,
    justifyContent: 'unset',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'row',
    textTransform: 'none',
    alignItems: 'center',
    textAlign: 'center',
    outline: 'none',
    padding: `${mixins.navigation.iconVerticalSpacing}px 32px ${mixins.navigation.iconVerticalSpacing}px 16px`,
    width: mixins.navigation.barWidth + mixins.accountDrawer.width,
    '&:hover': {
      opacity: 1,
      color: `${mixins.navigation.iconHoverColor} !important`,
      background: `${mixins.navigation.hoverBackground} !important`,
      cursor: 'pointer',
    },
    transition: mixins.navigation.selectedIconAnimation,
  };
  return ({
    root: {
      width: '100%',
    },
    feedback: {
      color: `${palette.background.paper} !important`,
    },
    outlined: {
      borderColor: palette.background.paper,
    },
    iconButtonRoot: {
      color: palette.background.paper,
      outline: 'none !important',
    },
    flex: {
      flex: 1,
    },
    navbar: {
      zIndex: 1201,
      backgroundColor: mixins.navigation.headerColor,
      width: mixins.navigation.barWidth,
      left: 0,
      height: '100%',
      overflow: 'hidden',
      transition: 'width .25s ease',
      boxShadow: shadows[4],
      maxHeight: '100vh',
      '&.expand': {
        width: mixins.navigation.barWidthOpen,
        transitionDelay: '300ms',
      },
      '&.closed': {
        width: mixins.navigation.barWidth,
        transitionDelay: '300ms',
      },
    },
    staticNav: {
      zIndex: 1201,
      backgroundColor: mixins.navigation.headerColor,
      width: mixins.navigation.barWidth,
      left: 0,
      height: '100%',
    },
    navItemsHolder: {
      display: 'flex',
      flexDirection: 'column-reverse',
      marginTop: 0,
      textAlign: 'left',
      width: '100%',
    },
    toolbar: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: 0,
      padding: 0,
      alignItems: 'baseline',
    },
    rootButton: {
      minWidth: 0,
    },
    textButton: {
      paddingLeft: `${mixins.navigation.iconVerticalSpacing}px`,
    },
    logoSection: {
      height: defaults.headers.subHeaderHeightTall,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    logo: {
      height: 40,
      marginRight: 8,
    },
    logoText: {
      height: 48,
    },
    betaBadge: {
      backgroundColor: palette.warning.main,
      padding: '1px 2px',
      height: 'auto',
      borderRadius: 1,
      textTransform: 'none',
      lineHeight: 1,
      fontSize: 6,
    },
    navPopover: {
      display: 'flex',
      flexDirection: 'column',
      width: null, // theme.mixins.navigation.barWidth,
      overflow: 'hidden',
    },
    profilePopover: {
      minWidth: popOverWidth,
      backgroundColor: palette.surface.overlay,
    },
    profileHeader: {
      fontFamily: 'Roboto, sans-serif',
      color: palette.text.primary,
      minHeight: 110,
      padding: 20,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'visible',
      justifyContent: 'space-between',
      alignItems: 'center',
      textAlign: 'center',
      '& h3': {
        margin: 0,
        fontSize: 16,
      },
      '& p': {
        margin: '0 0 10px',
        fontSize: 14,
      },
    },
    profileDataset: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: 12,
      color: palette.text.primary,
      backgroundColor: palette.surface.subtle,
      borderTop: `1px solid ${palette.border.dark}`,
      borderBottom: `1px solid ${palette.border.dark}`,
      padding: '10px 20px 6px',
      '& p': {
        margin: 0,
        fontSize: 14,
      },
      '& p:first-of-type': {
        fontWeight: 600,
      },
      '& i': {
        fontSize: 18,
        display: 'inlineBlock',
        verticalAlign: 'sub',
        marginRight: 5,
      },
      '& hr': {
        height: 0,
        borderTop: `1px solid ${palette.border.dark}`,
        borderBottom: 'none',
      },
      '& a': {
        color: palette.text.primary,
        textDecoration: 'none',
      },
    },
    datasetListItemDefault: {
      paddingTop: 4,
      paddingBottom: 4,
    },
    navMenuItem,
    navMenuItemSupport: {
      ...navMenuItem,
      '&:focus': {
        background: 'inherit',
        color: mixins.navigation.iconColor,
      },
    },
    selectedItem: {
      color: `${mixins.navigation.selectedIconColor} !important`,
      background: `${mixins.navigation.selectedBackground} !important`,
      '&:hover': {
        opacity: 1,
        color: `${mixins.navigation.selectedIconColor} !important`,
        background: `${mixins.navigation.selectedBackground} !important`,
        cursor: 'pointer',
      },
    },

    navMenuItemBottom: {
      cursor: 'pointer',
      ...navMenuItem,
      padding: 'none',
    },
    navText: {
      color: mixins.navigation.textColor,
      marginLeft: 24,
      textAlign: 'left',
    },
    selectedNavText: {
      color: mixins.navigation.selectedTextColor,
    },

    navButtonBottom: {
      width: mixins.navigation.barWidth,
      display: 'flex',
      flexDirection: 'column',
      flexFlow: 'column',
      textAlign: 'center',
      textColor: palette.text.strong,
    },
    selectedIcon: {
      background: mixins.navigation.iconSelectedColor,
      borderLeft: `solid ${mixins.navigation.iconColor} 2px`,
      paddingLeft: 16,
      width: mixins.navigation.barWidth + mixins.accountDrawer.width,
    },
    profileFinancesTitle: {
      fontSize: 16,
      fontWeight: 500,
    },
    disableHover: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    circleButtonContainer: {
      padding: '16px 0 16px 16px',
      minWidth: 0,
    },
    circleButton: {
      width: 24,
      height: 24,
      backgroundColor: mixins.navigation.iconColor,
      opacity: mixins.navigation.iconOpacity,
    },
    firstNameLetter: {
      fontFamily: 'Roboto, sans-serif',
      color: mixins.navigation.headerColor,
      fontSize: 16,
      fontWeight: 600,
    },
    betaLabel: {
      flex: 'auto',
      fontSize: '18px',
      fontWeight: 200,
      letterSpacing: '.05rem',
      position: 'absolute',
      right: 5,
      top: 10,
    },
    financesButtonStyle: {
      color: palette.link,
    },
    datasetSwitchingContent: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    datasetSwitchingProgress: {
      marginTop: '30px',
    },
    appDiv: {
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minWidth: 56,
    },
    appBarContainer: {
      overflowY: 'auto',
      maxWidth: '100%',
      overflowX: 'hidden',
      scrollbarWidth: 'thin',
      scrollbarColor: `${applyOpacityToHex(mixins.navigation.iconColor, 0.5)} ${mixins.navigation.headerColor}`,
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: applyOpacityToHex(mixins.navigation.iconColor, 0.5),
        borderRadius: 8,
      },
      '&::-webkit-scrollbar': {
        backgroundColor: mixins.navigation.headerColor,
        width: 5,
      },
    },
    navBottomSection: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginTop: 'auto',
      marginBottom: 32,
      overflow: 'hidden',
      flexShrink: 0,
    },
    achievementsSpan: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      position: 'relative',
    },
    milestoneBadge: {
      height: 24,
      width: 24,
      marginRight: -8,
      position: 'relative',
    },
    mainNavSubMenu: {
      zIndex: 1200,
      top: '-58px',
      left: '232px',
    },
    mainNavChevronRightIcon: {
      position: 'absolute',
      left: '214px',
    },
    navItemText: {
      marginLeft: 24, 
      textAlign: 'left',
      fontSize: 16,
      lineHeight: '19px',
    },
    spinnerButton: {
      padding: 0,
      marginRight: 5,
    },
    moreNavSubMenu: {
      top: '-70px',
    },
    textEllipsis: {
      overflow: 'hidden', 
      textOverflow: 'ellipsis', 
      whiteSpace: 'nowrap',
    },
    datasetNameWrapper: {
      maxWidth: 250,
    },
    expiredLabel: {
      marginLeft: 30,
      marginBottom: 15,
    },
    alert: {
      maxWidth: 370,
    },
    sharedAlert: {
      position: 'absolute',
      width: '100%',
      left: 0,
    },
  });
};
